import React from 'react';

// Tiny inline SVG trend line for snapshot tiles.
export function Sparkline({ values, width = 88, height = 22 }) {
  const pts = (values || []).filter((v) => v != null && !Number.isNaN(v));
  if (pts.length < 2) return null;
  const max = Math.max(...pts);
  const min = Math.min(...pts);
  const span = max - min || 1;
  const stepX = width / (pts.length - 1);
  const yFor = (v) => height - ((v - min) / span) * (height - 4) - 2;
  const coords = pts.map((v, i) => `${(i * stepX).toFixed(1)},${yFor(v).toFixed(1)}`).join(' ');
  const up = pts[pts.length - 1] >= pts[0];
  const color = up ? '#16a34a' : '#dc2626';
  const lastX = (pts.length - 1) * stepX;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}
      style={{ display: 'block', marginTop: 8 }} data-testid="snapshot-sparkline" aria-hidden="true">
      <polyline points={coords} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={lastX} cy={yFor(pts[pts.length - 1])} r="2.2" fill={color} />
    </svg>
  );
}
